<template>
  <div class="main">
    <p class="main-title fs20">{{$t('guild.InvitationCodeTitle')}}</p>
    <div class="main-box">
      <div class="main-size">{{ res }}</div>
      <div @click="handleCopy(res)">
        <img src="../../assets/Frame 71.svg" alt="" />
      </div>
    </div>

    <p class="main-title cfff">{{$t('guild.invite_rules_intriduction')}}</p>
    <div
      class="main-title"
      v-for="item in $t('guild.invite_rules_intriduction_content')"
      :key="item"
    >
      <p>{{ item }}</p>
    </div>
  </div>
</template>
  <script>
    import { Toast } from "vant";
export default {
  name: "App",
  data() {
    return {
      res: "",
      langType: "",
    };
  },
  created() {
    this.res = this.$route.query.verificationCode;
    this.langType = this.$route.query.langType;
    this.language()
  },
  mounted() {
  },
  methods: {
    handleCopy(data) {
      console.log(data);
      this.copy(data);
    },
    copy(data) {
      console.log(data);
      let url = data;
      //新建一个文本框
      let oInput = document.createElement("input");
      //赋值给文本框
      oInput.value = url;
      document.body.appendChild(oInput);
      // 选择对象;
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      Toast(this.$t('guild.guild_certification06'))
      //复制完成删除掉输入框
      oInput.remove();
    },
    language() {
      let langs = this.langType.substring(0, 2);
      let lang = this.langType;
      if (langs == "zh") {
        if (lang == "zh_TW" || lang == "zh_HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr"
      } else if (langs == "id") {
        this.$i18n.locale = "id"
      } else if (langs == "ms") {
        this.$i18n.locale = "ms"
      } else {
        this.$i18n.locale = "en";
      }
      //$t('guild.InvitationCodeTitle')
      document.title = this.$t('guild.InvitationCodeTitle')
    },
  },
};
</script>
  <style>
/* * {
    margin: 0;
    padding: 0;
  } */
.main {
  height: 100%;
  padding-top: 20px;
  box-sizing: border-box;
}
.main-title {
  width: 335px;
  margin: 10px auto;
  font-size: 16px;
}
.main-box {
  width: 335px;
  height: 76px;
  font-size: 22px;
  color: #23ddbc;
  background: #f3f3f5;
  margin: 30px auto;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-size {
  width: 223px;
  height: 26px;
  text-align: center;
}
ul li {
  padding-left: 13px;
  margin-top: 10px;
}
/* .main-title li {
  line-height: 30px;
} */
.cfff {
  color: #acadbc;
}
.fs20 {
  font-size: 20px;
}
</style>
